import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faYoutube, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const contactItems = [
  {
    icon: faMapMarkerAlt,
    label: 'Endereço',
    value: 'Av. Dep. Gastão Mariz de Faria\nNova Parnamirim, Parnamirim · RN',
    href: 'https://maps.google.com/?q=IGREJA+BATISTA+LAGOINHA+CIDADE+VERDE',
  },
  {
    icon: faPhone,
    label: 'WhatsApp',
    value: '(84) 99663-2025',
    href: 'https://wa.me/5584996632025',
    iconColor: 'text-emerald-400',
    iconBg: 'bg-emerald-500/10',
  },
  {
    icon: faEnvelope,
    label: 'Redes Sociais',
    value: '@igrejalagoinhacidadeverde',
    href: 'https://www.instagram.com/igrejalagoinhacidadeverde/',
  },
];

const socials = [
  { icon: faInstagram, href: 'https://www.instagram.com/igrejalagoinhacidadeverde/', label: 'Instagram' },
  { icon: faYoutube, href: 'https://www.youtube.com/@lagoinhacidadeverde', label: 'YouTube' },
  { icon: faWhatsapp, href: 'https://wa.me/5584996632025', label: 'WhatsApp' },
];

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-[#0d1526]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-16">
          <div className="section-label mx-auto w-fit">Fale Conosco</div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-tight">
            Entre em <span className="text-gradient">Contato</span>
          </h2>
          <p className="text-gray-500 mt-3">Será um prazer receber você!</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">

          {/* Informações */}
          <div className="flex flex-col gap-5">
            {contactItems.map(({ icon, label, value, href, iconColor = 'text-yellow-400', iconBg = 'bg-yellow-500/10' }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="glass-card glass-card-hover card-shine rounded-2xl p-6 flex items-start gap-4"
              >
                <div className={`${iconBg} w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0`}>
                  <FontAwesomeIcon icon={icon} className={`${iconColor} text-base`} />
                </div>
                <div>
                  <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-1">{label}</p>
                  <p className="text-white text-sm font-medium whitespace-pre-line">{value}</p>
                </div>
              </a>
            ))}

            {/* Redes sociais */}
            <div className="glass-card rounded-2xl p-6">
              <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-4">Nos siga</p>
              <div className="flex gap-3">
                {socials.map(({ icon, href, label }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="w-11 h-11 rounded-xl glass-card flex items-center justify-center text-gray-400 hover:text-yellow-400 hover:border-yellow-500/30 transition-all duration-200"
                  >
                    <FontAwesomeIcon icon={icon} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Mapa */}
          <div className="glass-card rounded-2xl overflow-hidden ring-1 ring-white/5">
            <iframe
              title="Localização Lagoinha Cidade Verde"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3968.625471444131!2d-35.1956106!3d-5.8943361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b2fc80044b9f009%3A0x7f4803f543d91dfe!2sIGREJA%20BATISTA%20LAGOINHA%20CIDADE%20VERDE!5e0!3m2!1spt-BR!2sbr!4v1709730000000!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '380px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
